export const createLead = `
  mutation CreateLead($input: CreateLeadInput!) {
    createLead(input:$input) {
      createLeadResult {
        successful
      }
      errors {
        ... on GenericError {
          message
        }
        ... on Error {
          message
        }
        ... on IGraphQlErrorBase {
          __typename
          message
        }
      }
    }
  }
`;

export default createLead;